import type { ReactNode } from 'react';

interface PillSelectProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  children: ReactNode;
}

/** Pill-shaped native `<select>` with its label glued inside the same field (design §6.3). */
const PillSelect = ({ label, value, onChange, children }: PillSelectProps) => (
  <label className="inline-flex h-[38px] items-center gap-1.5 rounded-[9px] border border-input bg-background px-3 text-[13px]">
    <span className="text-muted-foreground">{label}</span>
    <select
      aria-label={label}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="bg-transparent text-foreground focus:outline-none"
    >
      {children}
    </select>
  </label>
);

export default PillSelect;
